import LiveCasinoNumbersRedux from './live_casino_numbers_redux';

export default LiveCasinoNumbersRedux;
